<template>
  <div class="rule-box">
    <v-head :title="title"></v-head>
    <van-collapse v-model="activeNames" accordion>
      <van-collapse-item title="第一条" name="2">
        <div class="content">
            <p>本团体的会员包括个人会员和单位会员，以个人会员为主。本团体不吸收境外会员。</p>
        </div>
      </van-collapse-item>
      <van-collapse-item title="第二条 申请加入本团体必须具备下列条件：：" name="3">
        <div class="content">
            <p>（一）拥护本团体的章程；</p>
            <p>（二）有加入本团体的意愿；</p>
            <p>（三）具备下列条件之一的，可申请成为个人会员：</p>
            <p>1.具有相当助理研究员、讲师、工程师、技师等以上技术职务或职称及相当水平的文物科技工作者；</p>
            <p>2.高等学校本科毕业或自学成材，从事本学科工作三年以上并有实际工作经验和一定学术水平者；</p>
            <p>3.获得硕士学位以上的文物科技工作者；</p>
            <p>4.热心和积极支持、参与本会活动的其它学科科技工作者和有关部门的领导干部。</p>
            <p>（四）与本团体专业有关，具有一定数量的科技人员，愿意参加本团体有关活动，积极支持本团体工作的企事业单位以及依法登记的学术性社会团体，可以申请成为单位会员。</p>
            <p></p>
        </div>
      </van-collapse-item>
      <van-collapse-item title="第三条 申请加入本团体的程序：" name="4">
        <div class="content">
            <p>（一）提交书面入会申请；</p>
            <p>（二）经理事会或常务理事会讨论通过；</p>
            <p>（三）由理事会或理事会授权的机构发给会员证。</p>
        </div>
      </van-collapse-item>
      <van-collapse-item title="第四条 会员享有下列权利：" name="5">
        <div class="content">
            <p>（一）入会自愿，退会自由；</p>
            <p>（二）本团体的选举权、被选举权和表决权；</p>
            <p>（三）参加本团体的活动；</p>
            <p>（四）获得本团体服务的优先权和优惠权；</p>
            <p>（五）对本团体工作的批评建议和监督权；</p>
            <p>（六）本团体章程规定的其他权利。</p>
            <p></p>
        </div>
      </van-collapse-item>
      <van-collapse-item title="第五条 会员履行下列义务：" name="6">
        <div class="content">
            <p>（一）遵守本团体章程，执行本团体决议；</p>
            <p>（二）维护本团体合法权益；</p>
            <p>（三）完成本团体交办的工作；</p>
            <p>（四）向本团体反映情况，提供有关资料；</p>
            <p>（五）依规定按时缴纳会费；</p>
            <p>（六）本团体章程规定的其他义务。</p>
        </div>
      </van-collapse-item>
      <van-collapse-item title="第六条" name="7">
        <div class="content">
            <p>会员退会应书面通知本团体，并交回会员证。会员如果一年不缴纳会费或不参加本团体活动的，视为自动退会。</p>
        </div>
      </van-collapse-item>
        <van-collapse-item title="第七条" name="8">
            <div class="content">
                <p>会员如有严重违反本团体章程的行为，经理事会或常务理事会决定，予以除名。</p>
            </div>
        </van-collapse-item>
    </van-collapse>
  </div>
</template>

<script>
import vHead from "../../components/Subhead";
import { Collapse, CollapseItem } from "vant";

export default {
  data() {
    return {
      activeNames: '1',
      title:"入会须知"
    };
  },
  components: {
    vHead,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem
  }
};
</script>

<style lang="less" scoped>
.content{font-size:14px; line-height: 2; color: #333;}
p {
  margin-bottom: 10px;
  
   color: #333;
}
b {
  font-weight: bold;
  margin-right: 10px;
}
ul {
  li {
    margin: 5px 0;
    font-size:13px;
     color: #666;
  }
}
/deep/.van-cell{ padding:15px 20px;}
</style>

